<template>
    <div>
        <li><a href="/registration"><span>新規登録（無料）</span></a></li>
        <li><a href="/login"><span>ログイン</span></a></li>
        <li class="_about"><a href="/brand-list"><span>ブランド一覧</span></a></li>
        <!-- <li><a href="TODO: insert_link_url"><span>new collection一覧</span></a></li> -->
        <!-- <li><a href="TODO: insert_link_url"><span>hitotonari一覧</span></a></li> -->
        <li><a href="/showroom-list"><span>ショールーム一覧</span></a></li>
        <li class="_about">
            <button type="button" class="js-toggle-on"><span>AUMAについて（料金プラン）</span></button>
            <ul class="menu_lv2-nest">
                <div class="inner">
                    <li><a v-bind:href="route('brand.about')"><span>ブランド様用</span></a></li>
                    <li><a v-bind:href="route('shop.about')"><span>ショップ様用</span></a></li>
                    <li><a v-bind:href="route('showroom.about')"><span>ショールーム様用</span></a></li>
                </div>
            </ul>
        </li>
        <li>
            <button type="button" class="js-toggle-on"><span>ご利用ガイド</span></button>
            <ul class="menu_lv2-nest">
                <div class="inner">
                    <li><a  v-bind:href="route('brand.guide')"><span>ブランド様用</span></a></li>
                    <li><a  v-bind:href="route('shop.guide')"><span>ショップ様用</span></a></li>
                    <li><a  v-bind:href="route('showroom.guide')"><span>ショールーム様用</span></a></li>
                </div>
            </ul>
        </li>
        <li><a v-bind:href="route('faq')"><span>よくある質問</span></a></li>
        <li><a v-bind:href="route('CompanyInfo')"><span>運営会社情報</span></a></li>
        <li><a v-bind:href="route('terms.privacy')"><span>プライバシーポリシー</span></a></li>
        <li>
            <button type="button" class="js-toggle-on"><span>利用規約</span></button>
            <ul class="menu_lv2-nest">
                <div class="inner">
                    <li><a  v-bind:href="route('brand.rule')"><span>ブランド様用</span></a></li>
                    <li><a  v-bind:href="route('shop.rule')"><span>ショップ様用</span></a></li>
                    <li><a  v-bind:href="route('showroom.rule')"><span>ショールーム様用</span></a></li>
                </div>
            </ul>
        </li>
        <li><a href="mailto:support@auma.jp?subject=【AUMAサポート】問い合わせ&amp;body=ご記入ください"><span>お問合せ</span></a></li>
    </div>
</template>
